import { safeFetch } from "@/api/safeFetch";
import { Empleo, Oferta, OfertaLayout } from "../types/landingSections";



export const updateOfertasLanding = async (
    perfilId: number,
    ofertas: Oferta[]
): Promise<{ ok: boolean; data: Oferta[] }> => {
    return safeFetch.json(`/api/landingOfertas/${perfilId}/ofertas`, {
        method: "PUT",
        body: { ofertas },
    });
};

// =========================
// CREAR OFERTA VACÍA EN DB
// =========================
export const crearOfertaLanding = async (
    perfilId: number,
    oferta: {
        titulo: string;
        descripcion: string;
        precio: number | null;
        layout: OfertaLayout;
    }
): Promise<Oferta> => {

    const res = await safeFetch.json<{ ok: boolean; data: Oferta }>(
        `/api/landingOfertas/${perfilId}/ofertas`,
        {
            method: "PUT",
            body: { ofertas: [oferta] }
        }
    );
    // res ya es JSON
    if (!res.ok) {
        throw new Error("Error creando oferta");
    }

    return {
        id: crypto.randomUUID(),
        titulo: oferta.titulo,
        descripcion: oferta.descripcion,
        precio: oferta.precio,
        imagenes: [],
        layout: oferta.layout,
    };
};

export const getOfertasLanding = async (perfilId: number) => {
  return safeFetch.json<{
    ok: boolean;
    data: Oferta[];
  }>(`/api/landingOfertas/${perfilId}/ofertas`);
};

export const updateEmpleosLanding = async (
    perfilId: number,
    empleos: Empleo[]
): Promise<{ ok: boolean; data: Empleo[] }> => {

    return safeFetch.json(
        `/api/landingEmpleos/${perfilId}/empleos`,
        {
            method: "PUT",
            body: { empleos },
        }
    );
};

export const getEmpleosLanding = async (
    perfilId: number
): Promise<{ ok: boolean; data: Empleo[] }> => {

    return safeFetch.json(`/api/landingEmpleos/${perfilId}/empleos`);

};